import { Route, Routes } from "react-router-dom";
import { Container, Box, useTheme } from "@mui/material";
import Home from "./Pages/Home/Home";
import { ROUTESE } from "./routes/routes";
import Layout from "./Components/Layout/Layout";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { refreshThunk } from "./redux/state/authReduser/services";
import { SnackbarProvider } from "notistack";


function App() {
  const dispatch = useDispatch();
  const theme = useTheme();

  useEffect(() => {
    dispatch(refreshThunk());
  }, [dispatch]);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
      }}
    >
      
      <Layout>
        <Container maxWidth="lg" sx={{ paddingTop: 3, paddingBottom: 3 }}>
          <SnackbarProvider maxSnack={3}>
            <Routes>
              {ROUTESE.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}
              <Route path="*" element={<Home />} />
            </Routes>
          </SnackbarProvider>
        </Container>
      </Layout>
    </Box>
  );
}

export default App;
